import type Position from './position';
import ModelPosition from './model-position';
import NonEmptyText from './non-empty-text';
import NonNegativeNumber from './non-negative-number';
import Order from './order';
import PositiveInteger from './positive-integer';
import Price from './price';
import { getCurrency } from './sales/mock';
import TextPosition from './text-position';

const lorem = ['lorem', 'ipsum', 'dolor', 'sit', 'amet', 'consectetur', 'adipiscing', 'elit', 'sed', 'do', 'eiusmod', 'tempor'] as const;

export function getMockOrder(): Order {
	return new Order({
		modificationDate: new Date(),
		modificationDeadline: null,
		orderDate: new Date(),
		orderNumber: getRandomOrderNumber(),
		positions: getRandomPositions(0.5),
	});
}

export function getRandomLoremIpsumParagraph(min = 1, max = 5): string {
	const count = Math.round(Math.random() * (max - min) + min);
	let text = '';
	for (let index = 0; index < count; index++) {
		text += `${getRandomLoremIpsumWord()} `;
	}
	text = text.charAt(0).toUpperCase() + text.slice(1);
	return `${text.trim()}`;
}

export function getRandomLoremIpsumWord(): string {
	const index = Math.floor(Math.random() * lorem.length);
	return String(lorem[index]);
}

export function getRandomModelPosition(index: number, parent: null | Position = null): ModelPosition {
	return new ModelPosition({
		description: new NonEmptyText('3-lags træ vindue RP'),
		height: getRandomSize(),
		index: new PositiveInteger(index),
		litra: null,
		model: new NonEmptyText('12VU2-EV1-RP'),
		note: null,
		parent,
		price: getRandomPrice(),
		quantity: getRandomQuantity(),
		width: getRandomSize(),
	});
}

export function getRandomNonEmptyText(min = 1, max = 5): NonEmptyText {
	return new NonEmptyText(getRandomLoremIpsumParagraph(min, max));
}

export function getRandomNonEmptyTextOrNull(randomness: number): NonEmptyText | null {
	if (Math.random() < randomness) {
		return new NonEmptyText(getRandomLoremIpsumParagraph(5, 15));
	}
	return null;
}

export function getRandomOrderNumber(): PositiveInteger {
	return new PositiveInteger(Math.round(Math.random() * 1_000_000_000) + 10_000_000_000);
}

export function getRandomPositions(randomness: number): (ModelPosition | TextPosition)[] {
	const positions: (ModelPosition | TextPosition)[] = [];
	const count = Math.round(Math.random() * 50 + 10);
	for (let index = 1; index <= count; index++) {
		if (Math.random() < randomness) {
			addRandomTextPositionToArray(index, randomness, positions);
		} else {
			addRandomModelPositionToArray(index, randomness, positions);
		}
	}
	return positions;
}

export function getRandomPrice(): Price {
	const costPrice = new NonNegativeNumber(Math.round(Math.random() * 1_000) + 1000);
	const listPrice = new NonNegativeNumber(Math.round(Math.random() * 30_000) + 2000);
	const salesPrice = new NonNegativeNumber(Math.round(Math.random() * 30_000) + 2000);
	const currency = getCurrency();
	return new Price({
		costPrice,
		currency,
		discount: null,
		listPrice,
		salesPrice,
	});
}

export function getRandomQuantity(): PositiveInteger {
	const n = Math.round(Math.random() * 10 + 1);
	return new PositiveInteger(n);
}

export function getRandomSize(): PositiveInteger {
	const n = Math.round(Math.random() * 999) + 1001;
	return new PositiveInteger(n);
}

export function getRandomTextPosition(index: number, parent: null | Position = null): TextPosition {
	return new TextPosition({
		description: getRandomNonEmptyText(5, 15),
		index: new PositiveInteger(index),
		litra: getRandomNonEmptyText(5, 15),
		note: getRandomNonEmptyText(5, 15),
		parent,
		price: getRandomPrice(),
		quantity: new PositiveInteger(1),
		text: getRandomNonEmptyText(5, 15),
	});
}

function addRandomModelPositionToArray(index: number, randomness: number, array: (ModelPosition | TextPosition)[]): void {
	const position = getRandomModelPosition(index);
	array.push(position);
	if (Math.random() < randomness) {
		array.push(getRandomModelPosition(index, position));
	}
}

function addRandomTextPositionToArray(index: number, randomness: number, array: (ModelPosition | TextPosition)[]): void {
	const position = getRandomTextPosition(index);
	array.push(position);
	if (Math.random() < randomness) {
		array.push(getRandomTextPosition(index, position));
	}
}
